import {Section} from '..';
import {Typography} from '@material-ui/core';
import {AutoField} from '../fields';
import {useFieldData} from '../hooks';
import {getInitialValues, getSchema} from 'components/forms/AutoSection';

const DeliveryAddress = ({
    sectionName,
    sectionFields,
    existingData,
    fieldDict,
    ...props
}) => {
    const schema = getSchema(sectionFields, fieldDict);
    const initialValues = getInitialValues(
        existingData,
        sectionFields,
        fieldDict
    );

    const [sameAsHome, setSameAsHome] = useFieldData(
        'applicant_delivery_same_as_home'
    );

    return (
        <Section {...props} schema={schema} initialValues={initialValues}>
            <Typography variant='h6' align='left'>
                {sectionName}
            </Typography>
            <AutoField
                field={fieldDict['applicant_delivery_same_as_home']}
                name='applicant_delivery_same_as_home'
                onChange={e => setSameAsHome(e.target.value === 'true')}
            />
            {(sameAsHome === false || sameAsHome === 'false') &&
                [
                    'applicant_delivery_address_street',
                    'applicant_delivery_address_city',
                    'applicant_delivery_address_state',
                    'applicant_delivery_address_zip',
                ].map(field => {
                    return (
                        <AutoField
                            field={fieldDict[field]}
                            name={field}
                            key={field}
                        />
                    );
                })}
        </Section>
    );
};

export default DeliveryAddress;
